import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Combobox } from "./Combobox";
function customerFilter(item, query) {
    const q = query.toLowerCase();
    return (item.name?.toLowerCase().includes(q) ?? false) || (item.email?.toLowerCase().includes(q) ?? false) || item.id.toLowerCase().includes(q);
}
function customerDisplayValue(item) {
    return `${item.name ?? ''} (${item.email ?? ''}) [${item.id}]`;
}
function CustomerItem({ customer }) {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "font-medium truncate",
                children: customer.name
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-xs text-gray-500 truncate",
                children: customer.email
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-xs text-gray-400 font-mono truncate",
                children: customer.id
            })
        ]
    });
}
export function CustomerCombobox({ customers, value, onChange, groups, label, placeholder = 'Search customers...', errors, disabled, className, inputClassName, panelClassName }) {
    const renderItem = useMemo(()=>(item)=>/*#__PURE__*/ _jsx(CustomerItem, {
                customer: item
            }), []);
    return /*#__PURE__*/ _jsx(Combobox, {
        items: groups ? undefined : customers,
        groups: groups,
        value: value,
        onChange: onChange,
        filterFn: customerFilter,
        renderItem: renderItem,
        displayValue: customerDisplayValue,
        placeholder: placeholder,
        label: label,
        errors: errors,
        disabled: disabled,
        className: className,
        inputClassName: inputClassName,
        panelClassName: panelClassName,
        emptyMessage: "No customers found."
    });
}
